export function convertToPixels(value) {
    // Check if the value ends with 'vw' or 'vh'
    if (typeof value === 'string' && (value.endsWith('vw') || value.endsWith('vh'))) {
        // Get the numeric part of the value
        const numericValue = parseFloat(value);

        // Get the viewport width and height in pixels
        const viewportWidthInPixels = window.innerWidth;
        const viewportHeightInPixels = window.innerHeight;

        // Calculate the pixel value based on 'vw' or 'vh'
        if (value.endsWith('vw')) {
            return (numericValue / 100) * viewportWidthInPixels;
        } else {
            return (numericValue / 100) * viewportHeightInPixels;
        }
    }

    // If the input is not in the correct format, return it as is
    return value;
}
